define(
    'viewmodels/secured/app',[
        "plugins/router",
        "services/config",
        "services/session",
        "services/storage",
        "providers/dataprovider",
        "viewmodels/ViewModel"
    ],
    function (rootRouter, config, session, store, dataProvider, ViewModel) {
        var _app = false;
        var router = rootRouter
            .createChildRouter()
            .makeRelative({
                moduleId: "viewmodels/secured",
                fromParent: true
            });
        var app = new ViewModel(
        {
            hasCodeBehind: true,
            router: router
        });

        app.activate = function () {
            var d = $.Deferred();

            if (!_app) {
                config
                .buildChildRoutes()
                .done(function (data) {
                    app.router.map(data);

                    _app = true;

                    d.resolve();
                });
            } else {
                d.resolve();
            }

            return d.promise();
        }

        return app;
    }
);
